import { Container, Stack } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

import { AppFooter } from '../AppFooter';

import { Header } from './Header';

export const DashboardLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Stack minHeight="100vh">
      <Header />
      <Container
        maxWidth="xl"
        sx={{
          flex: '1 0 auto',
          display: 'flex',
          flexDirection: 'column',
          pt: 2,
          pb: 0,
        }}
      >
        {children}
      </Container>
      <AppFooter />
    </Stack>
  );
};
